import gql from "graphql-tag";

export const resourceFragment = gql`
  fragment resource on Resource {
    id
    _metadata
    _shadow
  }
`;
